/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
import { useEffect, useMemo, useState, useReducer } from "react";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { FiSave } from "react-icons/fi";
import { Table } from "reactstrap";
import { Loader } from "..";
import { useAuthContext } from "../../context/auth";
import { getCategorias, getIntermediarios, getClientes, getUsers, updateCliente } from "../../utils";
import styles from "./stylesClientesListado.module.scss";

// Separate component for list items
const ContactListItem = ({ index, value, onChange, users, role, excludeIds, paisMap, pais }) => {
  const [, forceItemUpdate] = useReducer(x => x + 1, 0);

  // Filtrar y ordenar usuarios alfabéticamente por nombre y luego apellido
  const sortedUsers = useMemo(() => users
    .filter(
      (user) =>
        user.rol === role &&
          user.pais === (paisMap[pais] || pais) &&
          !excludeIds.includes(String(user.id))
    )
    .sort((a, b) => {
      const nombreComparison = a.nombre.localeCompare(b.nombre);
      return nombreComparison !== 0 ? nombreComparison : a.apellido.localeCompare(b.apellido);
    }), [users, role, excludeIds, paisMap, pais]);

  return (
    <div key={`contact-${index}`} className={styles.contactoClienteItem}>
      <select
        key={`${value || "default"}-${index}-${Date.now()}`} // Unique key with timestamp
        className={`${styles.smallInput} mb-1 ${styles.contactoClienteDropdown}`}
        value={value || ""}
        onChange={(e) => {
          const selectedValue = e.target.value;
          onChange(selectedValue === "" ? null : selectedValue);
          forceItemUpdate(); // Force re-render for this item
        }}
      >
        <option value="">Desasociar</option>
        {sortedUsers.map((user) => (
          <option key={user.id} value={user.id}>
            {`${user.nombre} ${user.apellido}`}
          </option>
        ))}
      </select>
    </div>
  );
};

export const ClientesListado = () => {
  const [clientes, setClientes] = useState();
  const [categorias, setCategorias] = useState();
  const [intermediarios, setIntermediarios] = useState();
  const [usuarios, setUsuarios] = useState();
  const [editingClienteId, setEditingClienteId] = useState(null);
  const [editContactoCliente, setEditContactoCliente] = useState(null);
  const [editContactoClienteList, setEditContactoClienteList] = useState([]);
  const [editContactoAgencia, setEditContactoAgencia] = useState(null);
  const [editContactoAgenciaList, setEditContactoAgenciaList] = useState([]);
  const [dropdownCountCliente, setDropdownCountCliente] = useState(1);
  const [dropdownCountAgencia, setDropdownCountAgencia] = useState(1);
  const [editCategoriaCliente, setEditCategoriaCliente] = useState(null);
  const [editIntermediario, setEditIntermediario] = useState(null);
  const [filtroEmpresa, setFiltroEmpresa] = useState("");
  const [filtroProducto, setFiltroProducto] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const [editEjecutivosAsignados, setEditEjecutivosAsignados] = useState([]);
  const [dropdownCountEjecutivos, setDropdownCountEjecutivos] = useState(1);

  const { pais, rol, id } = useAuthContext();

  const categoriaMap = useMemo(() => {
    const map = {};
    if (categorias) {
      categorias.forEach(({ id, nombre }) => {
        map[id] = nombre;
      });
    }
    return map;
  }, [categorias]);

  const intermediarioMap = useMemo(() => {
    const map = {};
    if (intermediarios) {
      intermediarios.forEach(({ id, nombre }) => {
        map[id] = nombre;
      });
    }
    return map;
  }, [intermediarios]);

  const contactoMap = useMemo(() => {
    const map = {};
    if (usuarios) {
      usuarios.forEach(({ id, nombre, apellido }) => {
        map[id] = `${nombre} ${apellido}`.trim();
      });
    }
    return map;
  }, [usuarios]);

  const paisMap = {
    Perú: "PER",
    Chile: "CHI",
    Uruguay: "URU",
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        const [newClientes, newIntermediarios, newCategorias, newUsuarios] = await Promise.all([
          getClientes({ pais }),
          getIntermediarios({ pais }),
          getCategorias(),
          getUsers(),
        ]);

        setClientes(newClientes);
        setIntermediarios(newIntermediarios);
        setCategorias(newCategorias);
        setUsuarios(newUsuarios);
      } catch {
        toast.error("Error al cargar los datos");
      }
    };

    initialize();
  }, [pais]);

  const canEdit = (cliente) =>
    rol === "superadmin" ||
    rol === "gerencia" ||
    (pais === "Chile" && cliente.ejecutivos_asignados?.includes(Number(id))) ||
    (pais === "Perú" && rol === "comercial") ||
    (rol === "comercial" && String(id) === String(cliente.ejecutivo));

  const handleUpdateCliente = async (clienteId, originalCliente) => {
    try {
      const updatedData = {
        id: clienteId,
        ultimo_contacto_fecha: originalCliente.ultimo_contacto_fecha,
        ultimo_contacto_accion: originalCliente.ultimo_contacto_accion,
        proximo_contacto_fecha: originalCliente.proximo_contacto_fecha,
        proximo_contacto_accion: originalCliente.proximo_contacto_accion,
        contactoId: originalCliente.contactoId,
        contacto_cliente: editContactoCliente === null ? null : editContactoCliente ? Number(editContactoCliente) : originalCliente.contacto_cliente,
        contacto_cliente_1: editContactoClienteList[0] === null ? null : editContactoClienteList[0] ? Number(editContactoClienteList[0]) : originalCliente.contacto_cliente_1 || null,
        contacto_cliente_2: editContactoClienteList[1] === null ? null : editContactoClienteList[1] ? Number(editContactoClienteList[1]) : originalCliente.contacto_cliente_2 || null,
        contacto_cliente_3: editContactoClienteList[2] === null ? null : editContactoClienteList[2] ? Number(editContactoClienteList[2]) : originalCliente.contacto_cliente_3 || null,
        contacto_agencia: editContactoAgencia === null ? null : editContactoAgencia ? Number(editContactoAgencia) : originalCliente.contacto_agencia,
        contacto_agencia_1: editContactoAgenciaList[0] === null ? null : editContactoAgenciaList[0] ? Number(editContactoAgenciaList[0]) : originalCliente.contacto_agencia_1 || null,
        contacto_agencia_2: editContactoAgenciaList[1] === null ? null : editContactoAgenciaList[1] ? Number(editContactoAgenciaList[1]) : originalCliente.contacto_agencia_2 || null,
        contacto_agencia_3: editContactoAgenciaList[2] === null ? null : editContactoAgenciaList[2] ? Number(editContactoAgenciaList[2]) : originalCliente.contacto_agencia_3 || null,
        categoria_cliente: editCategoriaCliente !== null && editCategoriaCliente !== undefined ? editCategoriaCliente || null : originalCliente.categoria_cliente,
        agencia: editIntermediario !== null && editIntermediario !== undefined ? (editIntermediario ? Number(editIntermediario) : null) : originalCliente.agencia,
        ejecutivos_asignados: editEjecutivosAsignados.filter(id => id).map(Number), // Save as array of numbers, filtering empty
      };

      const hasChanges =
        (editContactoCliente === null && originalCliente.contacto_cliente !== null) ||
        (editContactoCliente !== null && editContactoCliente !== String(originalCliente.contacto_cliente)) ||
        editContactoClienteList.some((contactId, index) => {
          const originalField = index === 0 ? originalCliente.contacto_cliente_1 : index === 1 ? originalCliente.contacto_cliente_2 : originalCliente.contacto_cliente_3;
          return (contactId === null && originalField !== null) || (contactId && Number(contactId) !== originalField);
        }) ||
        (editContactoAgencia === null && originalCliente.contacto_agencia !== null) ||
        (editContactoAgencia !== null && editContactoAgencia !== String(originalCliente.contacto_agencia)) ||
        editContactoAgenciaList.some((contactId, index) => {
          const originalField = index === 0 ? originalCliente.contacto_agencia_1 : index === 1 ? originalCliente.contacto_agencia_2 : originalCliente.contacto_agencia_3;
          return (contactId === null && originalField !== null) || (contactId && Number(contactId) !== originalField);
        }) ||
        editCategoriaCliente !== originalCliente.categoria_cliente ||
        editIntermediario !== originalCliente.agencia ||
        !arraysEqual(editEjecutivosAsignados.filter(id => id), originalCliente.ejecutivos_asignados || []); // Check for executives changes

      if (hasChanges) {
        await updateCliente(updatedData);
        setClientes(
          clientes.map((cliente) =>
            cliente.id === clienteId
              ? {
                  ...cliente,
                  contacto_cliente: updatedData.contacto_cliente,
                  contacto_cliente_1: updatedData.contacto_cliente_1,
                  contacto_cliente_2: updatedData.contacto_cliente_2,
                  contacto_cliente_3: updatedData.contacto_cliente_3,
                  contacto_agencia: updatedData.contacto_agencia,
                  contacto_agencia_1: updatedData.contacto_agencia_1,
                  contacto_agencia_2: updatedData.contacto_agencia_2,
                  contacto_agencia_3: updatedData.contacto_agencia_3,
                  categoria_cliente: updatedData.categoria_cliente,
                  agencia: updatedData.agencia,
                  ejecutivo: updatedData.ejecutivo,
                  ejecutivos_asignados: updatedData.ejecutivos_asignados,
                }
              : cliente
          )
        );
        toast.success("Cliente actualizado correctamente");
      } else {
        toast("No se realizaron cambios");
      }
      setEditingClienteId(null);
      setEditContactoCliente(null);
      setEditContactoClienteList([]);
      setEditContactoAgencia(null);
      setEditContactoAgenciaList([]);
      setDropdownCountCliente(1);
      setDropdownCountAgencia(1);
      setEditCategoriaCliente(null);
      setEditIntermediario(null);
      setEditEjecutivosAsignados([]);
      setDropdownCountEjecutivos(1);
    } catch (error) {
      console.error("Error al actualizar cliente:", error.message);
      if (error.message.includes("network") || error.message.includes("timeout")) {
        toast.error("Error de conexión. Intenta de nuevo.");
      } else {
        toast.error("Error al actualizar el cliente. Contacta al soporte.");
      }
    }
  };

  const arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    return a.every((val, index) => Number(val) === b[index]);
  };

  const renderEmpresaOptions = () => {
    const empresasMap = new Map();
    clientes?.forEach((cliente) => {
      if (cliente.empresa && !empresasMap.has(cliente.empresa)) {
        empresasMap.set(cliente.empresa, cliente);
      }
    });

    const empresas = [...empresasMap.values()].sort((a, b) => a.empresa.localeCompare(b.empresa));

    return empresas.map((cliente) => (
      <option key={cliente.id} value={cliente.id}>
        {cliente.empresa}
      </option>
    ));
  };

  const renderProductoOptions = () => {
    const clientesFiltradosPorEmpresa = filtroEmpresa
      ? clientes?.filter((cliente) => {
        const empresaCliente = clientes?.find((c) => c.id === Number(filtroEmpresa))?.empresa;
        return cliente.empresa === empresaCliente;
      })
      : clientes;

    const productosMap = new Map();
    clientesFiltradosPorEmpresa?.forEach((cliente) => {
      if (cliente.producto && !productosMap.has(cliente.producto)) {
        productosMap.set(cliente.producto, cliente);
      }
    });

    const productos = [...productosMap.values()].sort((a, b) => a.producto.localeCompare(b.producto));

    return productos.map((cliente) => (
      <option key={cliente.id} value={cliente.id}>
        {cliente.producto}
      </option>
    ));
  };

  const renderTipoOptions = () => {
    const tipos = ["A", "B", "C"];
    return tipos.map((tipo) => (
      <option key={tipo} value={tipo}>
        {tipo}
      </option>
    ));
  };

  const renderCategoriaOptions = () =>
    categorias
      ?.sort((a, b) => a.nombre.localeCompare(b.nombre))
      .map((categoria) => (
        <option key={categoria.id} value={categoria.id}>
          {categoria.nombre}
        </option>
      ));

  const renderIntermediariosOptions = () =>
    intermediarios
      ?.sort((a, b) => a.nombre.localeCompare(b.nombre))
      .map((intermediario) => (
        <option key={intermediario.id} value={intermediario.id}>
          {intermediario.nombre}
        </option>
      ));

  const renderEjecutivosOptions = () => {
    const paisCode = paisMap[pais] || pais;

    return usuarios
      ?.filter((user) => ["gerencia", "comercial"].includes(user.rol) && user.pais === paisCode)
      .sort((a, b) => {
        const nombreComparison = a.nombre.localeCompare(b.nombre);
        return nombreComparison !== 0 ? nombreComparison : a.apellido.localeCompare(b.apellido);
      })
      .map((user) => (
        <option key={user.id} value={user.id}>
          {`${user.nombre} ${user.apellido}`}
        </option>
      ));
  };

  const clientesFiltrados = clientes?.filter((cliente) => {
    const empresaSeleccionada = filtroEmpresa ? clientes?.find((c) => c.id === Number(filtroEmpresa))?.empresa : null;
    const empresaMatch = !filtroEmpresa || cliente.empresa === empresaSeleccionada;
    const productoMatch = !filtroProducto || String(cliente.id) === String(filtroProducto);
    const tipoMatch = !filtroTipo || cliente.categoria_cliente === filtroTipo;
    const categoriaMatch = !filtroCategoria || String(cliente.categoria) === String(filtroCategoria);
    const intermediarioMatch = !filtroIntermediario || String(cliente.agencia) === String(filtroIntermediario);
    const ejecutivoMatch = !filtroEjecutivo || String(cliente.ejecutivo) === String(filtroEjecutivo);

    return empresaMatch && productoMatch && tipoMatch && categoriaMatch && intermediarioMatch && ejecutivoMatch;
  });

  if (intermediarios === undefined || categorias === undefined || clientes === undefined || usuarios === undefined) {
    return <Loader />;
  }

  // Función para ordenar contactos alfabéticamente por nombre y luego apellido
  const sortContacts = (contactIds, role) => {
    const contactUsers = contactIds
      .filter(id => id)
      .map(id => usuarios.find(user => String(user.id) === String(id)))
      .filter(user => user); // Filtrar usuarios nulos
    return contactUsers.sort((a, b) => {
      const nombreComparison = a.nombre.localeCompare(b.nombre);
      return nombreComparison !== 0 ? nombreComparison : a.apellido.localeCompare(b.apellido);
    });
  };

  return (
    <div className={styles.clientesListado}>
      {/* Filtros */}
      <div className="row mb-3">
        <div className="col-md-12">
          <div className="d-flex gap-3" style={{ width: "100%" }}>
            <div style={{ width: "16.66%" }}>
              <select
                className={`form-control ${filtroEmpresa ? "active-filter" : ""}`}
                value={filtroEmpresa}
                onChange={(e) => {
                  setFiltroEmpresa(e.target.value);
                  setFiltroProducto("");
                }}
              >
                <option value="">Empresa/Marca</option>
                {renderEmpresaOptions()}
              </select>
            </div>
            <div style={{ width: "16.66%" }}>
              <select
                className={`form-control ${filtroProducto ? "active-filter" : ""}`}
                value={filtroProducto}
                onChange={(e) => setFiltroProducto(e.target.value)}
              >
                <option value="">Producto</option>
                {renderProductoOptions()}
              </select>
            </div>
            <div style={{ width: "16.66%" }}>
              <select
                className={`form-control ${filtroTipo ? "active-filter" : ""}`}
                value={filtroTipo}
                onChange={(e) => setFiltroTipo(e.target.value)}
              >
                <option value="">Tipo</option>
                {renderTipoOptions()}
              </select>
            </div>
            <div style={{ width: "16.66%" }}>
              <select
                className={`form-control ${filtroCategoria ? "active-filter" : ""}`}
                value={filtroCategoria}
                onChange={(e) => setFiltroCategoria(e.target.value)}
              >
                <option value="">Categoría</option>
                {renderCategoriaOptions()}
              </select>
            </div>
            <div style={{ width: "16.66%" }}>
              <select
                className={`form-control ${filtroIntermediario ? "active-filter" : ""}`}
                value={filtroIntermediario}
                onChange={(e) => setFiltroIntermediario(e.target.value)}
              >
                <option value="">Intermediario</option>
                {renderIntermediariosOptions()}
              </select>
            </div>
            <div style={{ width: "16.66%" }}>
              <select
                className={`form-control ${filtroEjecutivo ? "active-filter" : ""}`}
                value={filtroEjecutivo}
                onChange={(e) => setFiltroEjecutivo(e.target.value)}
              >
                <option value="">Ejecutivo</option>
                {renderEjecutivosOptions()}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla */}
      <Table responsive striped>
        <thead className="table-dark">
          <tr>
            <th>Empresa/Marca</th>
            <th>Producto</th>
            <th>Tipo</th>
            <th>Categoría</th>
            <th>Intermediario</th>
            <th>Ejecutivo/s</th>
            <th>Contacto Cliente</th>
            <th>Contacto Agencia</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {clientesFiltrados.map((cliente) => (
            <tr key={cliente.id}>
              <td>{cliente.empresa || "-"}</td>
              <td>{cliente.producto || "-"}</td>
              <td>
                {editingClienteId === cliente.id && canEdit(cliente) ? (
                  <select
                    className={styles.smallInput}
                    value={editCategoriaCliente || ""}
                    onChange={(e) => setEditCategoriaCliente(e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    {["A", "B", "C"].map((tipo) => (
                      <option key={tipo} value={tipo}>
                        {tipo}
                      </option>
                    ))}
                  </select>
                ) : (
                  cliente.categoria_cliente || "-"
                )}
              </td>
              <td>{categoriaMap[cliente.categoria] || "-"}</td>
              <td>
                {editingClienteId === cliente.id && canEdit(cliente) ? (
                  <select
                    className={styles.smallInput}
                    value={editIntermediario || ""}
                    onChange={(e) => setEditIntermediario(e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    {intermediarios
                      ?.sort((a, b) => a.nombre.localeCompare(b.nombre))
                      .map((intermediario) => (
                        <option key={intermediario.id} value={intermediario.id}>
                          {intermediario.nombre}
                        </option>
                      ))}
                  </select>
                ) : (
                  intermediarioMap[cliente.agencia] || "-"
                )}
              </td>
              <td>
                {editingClienteId === cliente.id && rol === "gerencia" ? (
                  <div className={styles.contactoWrapper}>
                    <div className={styles.contactoEjecutivosContainer}>
                      {Array.from({ length: dropdownCountEjecutivos }).map((_, index) => (
                        <div key={`executive-${index}`} className={styles.contactoEjecutivosItem}>
                          <select
                            className={`${styles.smallInput} mb-1 ${styles.contactoEjecutivosDropdown}`}
                            value={editEjecutivosAsignados[index] || ""}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              const newList = [...editEjecutivosAsignados];
                              newList[index] = newValue === "" ? null : newValue;
                              setEditEjecutivosAsignados(newList);
                              forceUpdate(); // Force re-render
                            }}
                          >
                            <option value="">Desasociar</option>
                            {usuarios
                              .filter(
                                (user) =>
                                  ["comercial", "gerencia"].includes(user.rol) &&
                    user.pais === (paisMap[pais] || pais) &&
                    user.habilitado !== false &&
                    !editEjecutivosAsignados.filter((id, i) => i !== index && id).includes(String(user.id))
                              )
                              .sort((a, b) => {
                                const nombreComparison = a.nombre.localeCompare(b.nombre);
                                return nombreComparison !== 0 ? nombreComparison : a.apellido.localeCompare(b.apellido);
                              })
                              .map((user) => (
                                <option key={user.id} value={user.id}>
                                  {`${user.nombre} ${user.apellido}`}
                                </option>
                              ))}
                          </select>
                        </div>
                      ))}
                      {dropdownCountEjecutivos < 4 && (
                        <div className={styles.contactoEjecutivosItem}>
                          <button
                            onClick={() => {
                              setDropdownCountEjecutivos(dropdownCountEjecutivos + 1);
                              setEditEjecutivosAsignados([...editEjecutivosAsignados, ""]);
                            }}
                            className={`btn btn-sm btn-outline-primary ${styles.addContactBtn}`}
                            disabled={dropdownCountEjecutivos >= 4}
                          >
              +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <ul className={`list-unstyled ${styles.contactoEjecutivoList}`}>
                    {cliente.ejecutivos_asignados?.length > 0 ? (
                      cliente.ejecutivos_asignados.map((id, index) => (
                        <li key={index}>{contactoMap[id] || "-"}</li>
                      ))
                    ) : (
                      <li>-</li>
                    )}
                  </ul>
                )}
              </td>
              <td>
                {editingClienteId === cliente.id && canEdit(cliente) ? (
                  <div className={styles.contactoWrapper}>
                    <div className={styles.contactoClienteContainer}>
                      <div className={styles.contactoClienteItem}>
                        <select
                          key={editContactoCliente || "default"}
                          className={`${styles.smallInput} ${styles.contactoClienteDropdown}`}
                          value={editContactoCliente || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setEditContactoCliente(selectedValue === "" ? null : selectedValue);
                            forceUpdate(); // Force re-render
                          }}
                        >
                          <option value="">Desasociar</option>
                          {usuarios
                            .filter(
                              (user) =>
                                user.rol === "cliente" &&
                                user.pais === (paisMap[pais] || pais) &&
                                !editContactoClienteList.includes(String(user.id))
                            )
                            .sort((a, b) => {
                              const nombreComparison = a.nombre.localeCompare(b.nombre);
                              return nombreComparison !== 0 ? nombreComparison : a.apellido.localeCompare(b.apellido);
                            })
                            .map((user) => (
                              <option key={user.id} value={user.id}>
                                {`${user.nombre} ${user.apellido}`}
                              </option>
                            ))}
                        </select>
                      </div>
                      {Array.from({ length: dropdownCountCliente - 1 }).map((_, index) => (
                        <ContactListItem
                          key={`client-${index}`}
                          index={index}
                          value={editContactoClienteList[index]}
                          onChange={(newValue) => {
                            const newList = [...editContactoClienteList];
                            newList[index] = newValue;
                            setEditContactoClienteList(newList);
                            forceUpdate(); // Force re-render
                          }}
                          users={usuarios}
                          role="cliente"
                          excludeIds={[editContactoCliente, ...editContactoClienteList.filter((id, i) => i !== index)].filter(Boolean)}
                          paisMap={paisMap}
                          pais={pais}
                        />
                      ))}
                      {dropdownCountCliente < 4 && (
                        <div className={styles.contactoClienteItem}>
                          <button
                            onClick={() => {
                              setDropdownCountCliente(dropdownCountCliente + 1);
                              setEditContactoClienteList([...editContactoClienteList, ""]);
                            }}
                            className={`btn btn-sm btn-outline-primary ${styles.addContactBtn}`}
                            disabled={dropdownCountCliente >= 4}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <ul className={`list-unstyled ${styles.contactoClienteList}`}>
                    {sortContacts(
                      [
                        cliente.contacto_cliente,
                        cliente.contacto_cliente_1,
                        cliente.contacto_cliente_2,
                        cliente.contacto_cliente_3
                      ],
                      "cliente"
                    ).map((user, index) => (
                      <li key={index}>{contactoMap[user.id] || "-"}</li>
                    ))}
                    {![
                      cliente.contacto_cliente,
                      cliente.contacto_cliente_1,
                      cliente.contacto_cliente_2,
                      cliente.contacto_cliente_3
                    ].some(id => id) && <li>-</li>}
                  </ul>
                )}
              </td>
              <td>
                {editingClienteId === cliente.id && canEdit(cliente) ? (
                  <div className={styles.contactoWrapper}>
                    <div className={styles.contactoAgenciaContainer}>
                      <div className={styles.contactoAgenciaItem}>
                        <select
                          key={editContactoAgencia || "default"}
                          className={`${styles.smallInput} mb-1 ${styles.contactoAgenciaDropdown}`}
                          value={editContactoAgencia || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setEditContactoAgencia(selectedValue === "" ? null : selectedValue);
                            forceUpdate(); // Force re-render
                          }}
                        >
                          <option value="">Desasociar</option>
                          {usuarios
                            .filter(
                              (user) =>
                                user.rol === "agencia" &&
                                user.pais === (paisMap[pais] || pais) &&
                                !editContactoAgenciaList.includes(String(user.id))
                            )
                            .sort((a, b) => {
                              const nombreComparison = a.nombre.localeCompare(b.nombre);
                              return nombreComparison !== 0 ? nombreComparison : a.apellido.localeCompare(b.apellido);
                            })
                            .map((user) => {
                              const intermediario = intermediarios.find((inter) => inter.id === user.agencia);
                              const intermediarioDisplay = intermediario
                                ? intermediario.nombre.includes("|")
                                  ? intermediario.nombre.split("|")[1].trim()
                                  : intermediario.nombre
                                : "";
                              return (
                                <option key={user.id} value={user.id}>
                                  {`${user.nombre} ${user.apellido}${intermediarioDisplay ? `, ${intermediarioDisplay}` : ""}`}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      {Array.from({ length: dropdownCountAgencia - 1 }).map((_, index) => (
                        <ContactListItem
                          key={`agency-${index}`}
                          index={index}
                          value={editContactoAgenciaList[index]}
                          onChange={(newValue) => {
                            const newList = [...editContactoAgenciaList];
                            newList[index] = newValue;
                            setEditContactoAgenciaList(newList);
                            forceUpdate(); // Force re-render
                          }}
                          users={usuarios}
                          role="agencia"
                          excludeIds={[editContactoAgencia, ...editContactoAgenciaList.filter((id, i) => i !== index)].filter(Boolean)}
                          paisMap={paisMap}
                          pais={pais}
                        />
                      ))}
                      {dropdownCountAgencia < 4 && (
                        <div className={styles.contactoAgenciaItem}>
                          <button
                            onClick={() => {
                              setDropdownCountAgencia(dropdownCountAgencia + 1);
                              setEditContactoAgenciaList([...editContactoAgenciaList, ""]);
                            }}
                            className={`btn btn-sm btn-outline-primary ${styles.addContactBtn}`}
                            disabled={dropdownCountAgencia >= 4}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <ul className={`list-unstyled ${styles.contactoAgenciaList}`}>
                    {sortContacts(
                      [
                        cliente.contacto_agencia,
                        cliente.contacto_agencia_1,
                        cliente.contacto_agencia_2,
                        cliente.contacto_agencia_3
                      ],
                      "agencia"
                    ).map((user, index) => (
                      <li key={index}>{contactoMap[user.id] || "-"}</li>
                    ))}
                    {![
                      cliente.contacto_agencia,
                      cliente.contacto_agencia_1,
                      cliente.contacto_agencia_2,
                      cliente.contacto_agencia_3
                    ].some(id => id) && <li>-</li>}
                  </ul>
                )}
              </td>
              <td className="text-center">
                {canEdit(cliente) ? (
                  editingClienteId === cliente.id ? (
                    <FiSave onClick={() => handleUpdateCliente(cliente.id, cliente)} style={{ cursor: "pointer" }} />
                  ) : (
                    <FaEdit
                      onClick={() => {
                        setEditingClienteId(cliente.id);
                        setEditContactoCliente(cliente.contacto_cliente || "");
                        setEditContactoClienteList([
                          cliente.contacto_cliente_1 || "",
                          cliente.contacto_cliente_2 || "",
                          cliente.contacto_cliente_3 || ""
                        ].filter(id => id !== ""));
                        setEditContactoAgencia(cliente.contacto_agencia || "");
                        setEditContactoAgenciaList([
                          cliente.contacto_agencia_1 || "",
                          cliente.contacto_agencia_2 || "",
                          cliente.contacto_agencia_3 || ""
                        ].filter(id => id !== ""));
                        setDropdownCountCliente(([cliente.contacto_cliente_1, cliente.contacto_cliente_2, cliente.contacto_cliente_3].filter(id => id).length || 0) + 1);
                        setDropdownCountAgencia(([cliente.contacto_agencia_1, cliente.contacto_agencia_2, cliente.contacto_agencia_3].filter(id => id).length || 0) + 1);
                        setEditCategoriaCliente(cliente.categoria_cliente || "");
                        setEditIntermediario(cliente.agencia || "");
                        setEditEjecutivosAsignados(cliente.ejecutivos_asignados?.map(String) || []);
                        setDropdownCountEjecutivos((cliente.ejecutivos_asignados?.length || 0) + (cliente.ejecutivos_asignados?.length < 4 ? 1 : 0));
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  )
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};